// GENERATED CODE - DO NOT EDIT
import { executeServiceRequest, executeUploadServiceRequest } from "../../lib/client-util/serviceRequest";
export const emailService = {
  sendContactRequest(
    name: string,
    emailAddress: string,
    comments: string,
  ): Promise<void> {
    return executeServiceRequest(
      "./services/FormidableDesigns.Services.V1.EmailService.SendContactRequest", {
        name,
        emailAddress,
        comments,
      }
    );
  },
}
export const testService = {
  testSimpleMethod(
    input: string,
  ): Promise<string> {
    return executeServiceRequest(
      "./services/FormidableDesigns.Services.V1.TestService.TestSimpleMethod", {
        input,
      }
    );
  },
  testFailedMethod(
  ): Promise<void> {
    return executeServiceRequest(
      "./services/FormidableDesigns.Services.V1.TestService.TestFailedMethod", {
      }
    );
  },
  testServiceMethod(
  ): Promise<void> {
    return executeServiceRequest(
      "./services/FormidableDesigns.Services.V1.TestService.TestServiceMethod", {
      }
    );
  },
}
